import { render, staticRenderFns } from "./Sponsor.vue?vue&type=template&id=5ce2707e&"
var script = {}
import style0 from "./Sponsor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports